import React, { ChangeEvent } from 'react'
import './component.scss'
import { useAppDispatch, useAppSelector } from '../app/hooks'
import { selectPageSize, setPageSize } from '../app/appSlice'
import { pageSizeOptions } from '../features/Radiology/Constants/constants'

type Props = {
  total: number
  current: number
  handleChange: () => void
}

const Pagination = ({ total, current, handleChange }: Props) => {
  const pageSize = useAppSelector(selectPageSize)
  const dispatch = useAppDispatch()
  const offset = (current - 1) * pageSize
  const start = offset + 1
  const end = Math.min(offset + pageSize, total)

  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    dispatch(setPageSize(Number(e.target.value)))
    handleChange()
  }

  return (
    <div className='inline-block membership-pagination text-right'>
      <select
        className='rowsperpage pagination-container'
        defaultValue={pageSize}
        onChange={handleSizeChange}
      >
        {pageSizeOptions?.map((size) => (
          <option key={size}>{size}</option>
        ))}
      </select>
      <span>
        <span className='mr10 pagination-container'>
          {start} -{end} / {total}{' '}
        </span>
      </span>
    </div>
  )
}

export default Pagination
